import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class DashboardTypes {
  static lastSales: IActionType = new ActionType('DASHBOARD/LAST_SALES');
  static dashValues: IActionType = new ActionType('DASHBOARD/DASH_VALUES');
  static lastLeads: IActionType = new ActionType('DASHBOARD/LAST_LEADS');
  static dashProducts: IActionType = new ActionType('DASHBOARD/DASH_PRODUCTS');
  static listNewzz: IActionType = new ActionType('DASHBOARD/LIST_NEWZZ');
  static clickNewzz: IActionType = new ActionType('DASHBOARD/CLICK_NEWZZ');
  static indications: IActionType = new ActionType('DASHBOARD/INDICATIONS');
  static bestsellers: IActionType = new ActionType('DASHBOARD/BEST_SELLERS');
  static periodSalesGain: IActionType = new ActionType('DASHBOARD/PERIOD_SALES_GAIN');
  static lastGain: IActionType = new ActionType('DASHBOARD/LAST_GAIN');
}

export default DashboardTypes;
